import OnboardingSection from './OnboardingSection';

export default OnboardingSection;
